import { createAction, props } from '@ngrx/store';

export const loadAuthFromStorage = createAction('[Auth] Load From Storage');

export const hydrateSuccess = createAction(
  '[Auth] Hydrate Success',
  props<{ token: string; roles: string[] }>()
);

export const clearAuthError = createAction('[Auth] Clear Error');

export const hydrateFailure = createAction('[Auth] Hydrate Failure');

export const login = createAction(
  '[Auth] Login',
  props<{ username: string; password: string }>()
);

export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: string }>()
);

export const logout = createAction('[Auth] Logout');
export const logoutSuccess = createAction('[Auth] Logout Success');

export const unauthorized = createAction('[Auth] Unauthorized');
